import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M16.941 19.657a8 8 0 0 1-8.465 1.833l-.269-.1a2 2 0 0 1-.712-3.287l1.39-1.39a2 2 0 0 1 2.828 0l.672.672a2 2 0 0 0 2.828 0l2.172-2.172a2 2 0 0 0 0-2.828l-.672-.672a2 2 0 0 1 0-2.828l1.39-1.39a2 2 0 0 1 3.286.712l.101.269a8 8 0 0 1-1.834 8.466z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M4.592 4.592a1 1 0 0 0 0 1.414L8.885 10.3H5.299a1 1 0 1 0 0 2h6a1 1 0 0 0 1-1v-6a1 1 0 1 0-2 0v3.586L6.006 4.592a1 1 0 0 0-1.414 0",
      clipRule: "evenodd"
    }
  )
);
var SvgCallInboundFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var CallInboundFilled_default = SvgCallInboundFilled;

export { CallInboundFilled_default as default };
